<template>
	<div class="viedo"  style="padding-top: 200px;">

		<!-- <video id="videoPlayer" class="video-js vjs-default-skin" controls width="800" height="600"></video> -->

		<!-- <video id="videoPlayer" class="video-js vjs-default-skin" controls width="640" height="264" autoplay="true">
			<source src="https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8" type="application/x-mpegURL">
		</video> -->

		<!-- <video id="videoPlayer" width="414" height="270" preload="auto" playsinline webkit-playsinline>
		</video> -->

		<video id="videoPlayer" ref="videoPlayer" width="414" preload="auto" playsinline webkit-playsinline>
		</video>

		

	</div>
</template>
<script>
// import 'videojs-contrib-hls'
// import TCPlayer from "video.js"; // 引入Videojs
// import TCPlayer from 'videojs-contrib-hls.js';
// import videojs from 'tcplayer.js';
// import 'tcplayer.js/dist/tcplayer.min.css';
import '../assets/js/PlayerButton'; // 引入自定义按钮组件
// import TCPlayer from 'tcplayer.js';


// import TCPlayer from 'tcplayer.js'


export default {
	data() {
		return {
			// options: {
			// // autoplay: true, // 设置自动播放
			// // muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
			// preload: "auto", // 预加载
			// controls: true, // 显示播放的控件
			// playbackRates: [0.5, 1, 1.25, 1.5, 2, 3], // 加上这个属性，可实现倍速播放
			// },
			player:null
		};
	},
	mounted() {
		this.iniPlayer()
	},
	computed: {

	},
	methods: {
		iniPlayer(){
// console.log(TCPlayer)
// this.player = TCPlayer("videoPlayer")
// this.player = TCPlayer(this.$refs.videoPlayer)

			// this.player = TCPlayer("videoPlayer");
			this.player = TCPlayer("videoPlayer",{
				sources: [{
					src: 'https://wiselife.blog/hls/69b01667a0913f89b5a3c53c.m3u8', // 播放地址
				}],
				URL:'',
// 				controlBar: {
//   children: ['playToggle', 'fullscreenToggle'] // 只显示播放/暂停和全屏按钮
// },
				language: 'ko',
				preload: "auto", // 预加载
				playbackRates: [0.5, 1, 1.25, 1.5, 2, 3],
				poster:'https://www.baidu.com/img/flexible/logo/pc/result.png',
				// muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
				autoplay:true,
				bigPlayButton:true,
				licenseUrl: 'license/url', // license 地址，必传。参考准备工作部分，在视立方控制台申请 license 后可获得 licenseUrl
			})

			this.player.controlBar.addChild('NewButton1', {}, 2); // 0 表示插入到第一个位置
    		this.player.controlBar.addChild('NewButton2', {}, 3); // 0 表示插入到第一个位置

		}
	}
}

</script>